<template>
    <v-data-table
            :headers="getHeaders"
            :items="items"
            :loading="loading"
            :loading-text="getLoadingText"
            :options.sync="options"
            :itemsPerPage="getItemsPerPage"
            :server-items-length="totalItems"
    >
        <template v-for="header in getHeaders" v-slot:[`item.${header.value}`]="{ item }">
            <slot :name="`item.${header.value}`" :item=item > {{item[header.value]}} </slot>
        </template>
    </v-data-table>
</template>

<script>
    //https://vuejs.org/v2/guide/components-slots.html#Scoped-Slots
    import alertEventBus from '@/eventBus/AlertEventBus';

    export default {
        name: "DataTable",
        props:['headers', 'itemsPerPage', 'loadingText', 'fetchFunction', 'tableId'],
        components: {
        },
        data(){
           return {
               items: [],
               loading: true,
               totalItems: 0,
               options: {},
               pageKeyCache: new Map(),
               keyId:''
           }
        },
        watch:{
            options:{
                async handler () {
                    await this.loadData();
                },
                deep: true
            },
            tableId : {
                deep: true,
                immediate: true,
                handler(value) {
                    this.$log.debug('new value for tableId ', value)
                    this.keyId = value;
                }
            }
        },
        computed:{
            getHeaders(){
                return this.headers;
            },
            getLoadingText(){
                return this.loadingText || 'Loading... Please wait';
            },
            getItemsPerPage(){
                return this.itemsPerPage || 5;
            },
            getFetchFunction(){
                return this.fetchFunction;
            },
        },
        methods:{
            async refresh(keyId){
                this.$log.debug('Calling refresh table!!');
                this.loading = true;
                this.items = [];
                this.options.page = 1;
                this.totalItems = 0;
                this.pageKeyCache = new Map();
                await this.loadData(keyId);
            },
            async loadData(keyId = this.keyId){
                this.loading = true;
                const { page,
                    itemsPerPage,
                  //  sortBy, descending,
                } = this.options;

                let params = {
                    limit: itemsPerPage
                };

                if(this.pageKeyCache.has(`${keyId}:${page - 1}`) && page != 1){
                    params.lastEvaluatedKey = this.pageKeyCache.get(`${keyId}:${page -1}`);
                }

                let data;
                try{
                    let fetch = this.getFetchFunction();
                    data = await fetch(params);
                }
                catch (e) {
                    this.loading = false;
                    alertEventBus.setAlert({type:'error', msg: e.message});
                    return ;
                }

                this.items = [];
                if(data.items)
                {
                    for(let document of data.items){
                        let item = {
                            ...document
                        };
                        this.items.push(item);
                    }

                    this.totalItems = itemsPerPage * (page - 1) + this.items.length;
                    if(data.lastEvaluatedKey != null) {
                        this.pageKeyCache.set(`${this.keyId}:${page}`, data.lastEvaluatedKey);
                        this.totalItems+=1;
                    }
                }

                this.loading = false;
            }
        }
    }
</script>

<style scoped>
    button:focus, button:active, button.active, button:focus:active {
        background-image: none;
        outline: none;
        -webkit-box-shadow: none;
        box-shadow: none;
    }
</style>